/**
 * @generated SignedSource<<2284738aaf97ba1e3cccc4ea455f5bf3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutTrackingActions_item$data = {
  readonly address: {
    readonly country: string | null;
  } | null;
  readonly classification: {
    readonly categories: ReadonlyArray<{
      readonly category: {
        readonly browseUrl: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly isAvailable: boolean | null;
  readonly pricing: {
    readonly negotiable: boolean | null;
  } | null;
  readonly returnPolicy: {
    readonly accept: boolean | null;
  } | null;
  readonly seller: {
    readonly serviceId: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "checkoutTrackingActions_item";
};
export type checkoutTrackingActions_item$key = {
  readonly " $data"?: checkoutTrackingActions_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutTrackingActions_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutTrackingActions_item"
};

(node as any).hash = "dee72407c07193c201f5129b59605741";

export default node;
